import { TextFieldForm } from "@/components/Elements/Forms";
import { VStack } from "@/components/Elements/Layouts";
import { InputLabel } from "@/components/Elements/Texts";
import { UseFormReturn } from "react-hook-form";

interface Props {
  label: string;
  name: string;
  form: UseFormReturn<any, any>;
  type?: string;
  placeholder?: string;
  required?: boolean;
}

export const LabeledTextFieldForm: React.FC<Props> = ({
  label,
  form,
  type,
  name,
  placeholder,
  required,
}) => {
  return (
    <VStack>
      <InputLabel required={required} label={label} />
      <TextFieldForm
        form={form}
        type={type ? type : "text"}
        name={name}
        placeholder={placeholder ? placeholder : ""}
        rules={
          required
            ? {
                required: {
                  value: true,
                  message: "この項目は必須です",
                },
              }
            : {}
        }
      />
    </VStack>
  );
};
